"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.csvArrayToBuffer = void 0;
const csvConversion = __importStar(require("./csvConversion"));
/**
 * DO NOT USE THIS FOR NEW CODE
 * TODO: remove this function as it's fairly non-performant and relies on a dated JS package
 *
 * Converts csvArray to Buffer
 * @param the csv Array (array of objects)
 * @returns the csv in Buffer format
 */
const csvArrayToBuffer = (csvArray) => {
    return csvConversion.csvArrayToFinleyBuffer({
        csvArray,
        newline: '\n', // csvjson default behavior outputs only a single newline, as opposed to papa parse default of CRLF (\r\n)
        quotes: true,
    });
};
exports.csvArrayToBuffer = csvArrayToBuffer;
//# sourceMappingURL=formatter.js.map